import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { AssemblyOverviewAddAssemblyPage } from '@/areas/assemblies/AssemblyForm/pages/AssemblyOverviewAddAssemblyPage';
import { assembliesEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/assemblies/$assemblyId/subassemblies/create')({
    staticData: {
        access: { permissions: ['create:assembly'], modulePermissions: assembliesEditModulePermissions },
        chrome: 'home',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ rfqId: 'required' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const rfqId = Route.useSearch({ select: (search) => search.rfqId });
    return <AssemblyOverviewAddAssemblyPage rfqId={rfqId} parentAssemblyId={pathParams.assemblyId} />;
}
